import { LazyModule, registerLazyOrchestrator } from 'owa-bundling';
import { userMailInteractionAction } from 'owa-mail-actions';
import { isFeatureEnabled } from 'owa-feature-flags';
import { runAfterInitialRender } from 'owa-delayed-initialization';
import { onMailSearchComplete } from 'owa-mail-actions/lib/mailSearchActions';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "TriagePatterns" */ './lazyIndex')
);

export { default as getUserInteractionContext } from './utils/getUserInteractionContext';

runAfterInitialRender(() => {
    if (isFeatureEnabled('tri-triagePattern')) {
        registerLazyOrchestrator(
            userMailInteractionAction,
            lazyModule,
            m => m.triagePatternsOrchestrator
        );
        registerLazyOrchestrator(
            onMailSearchComplete,
            lazyModule,
            m => m.triagePatternsOrchestratorForSearch
        );
    }
});
